export const isLoadingInsightsSelector = (state) =>
  state.newCompany.companyInsights.isLoading;
export const insightsSelector = (state) =>
  state.newCompany.companyInsights.data;
